import { Maybe } from 'graphql/generated';
import { useDomainConfig } from 'hooks/useDomainConfig';
import { useEffect, useRef } from 'react';
import { FriendlyUrlPageType } from 'types/friendlyUrl';
import { getGtmProductDetailEvent, getNewGtmEcommerceEvent } from 'utils/Gtm/EventFactories';
import { gtmSafePushEvent } from 'utils/Gtm/Gtm';

export const useGtmProductDetailView = (
    data: Maybe<FriendlyUrlPageType> | undefined,
    slug: string,
    fetching: boolean,
): void => {
    const event = getNewGtmEcommerceEvent('ec.product_view', true);
    const { currencyCode } = useDomainConfig();
    const lastViewedProductDetailSlug = useRef<string | undefined>(undefined);
    const { url } = useDomainConfig();

    useEffect(() => {
        if (
            data !== null &&
            data !== undefined &&
            (data.__typename === 'MainVariant' ||
                data.__typename === 'RegularProduct' ||
                data.__typename === 'Variant') &&
            lastViewedProductDetailSlug.current !== slug &&
            !fetching
        ) {
            lastViewedProductDetailSlug.current = slug;
            event.ecommerce = getGtmProductDetailEvent(data, currencyCode, url);
            gtmSafePushEvent(event);
        }
    }, [currencyCode, data, event, fetching, slug, url]);
};
